export default `
<div class="plyr__controls c-audio-bar__controls">
	<div class="plyr__controls__item plyr__time--current plyr__time" aria-label="Current time">00:00</div>
	<div class="plyr__controls__item plyr__progress__container">
		<div class="plyr__progress">
			<input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" autocomplete="off" role="slider" aria-label="Seek" aria-valuemin="0">
			<progress class="plyr__progress__buffer" min="0" max="100" value="0" role="progressbar" aria-hidden="true">% buffered</progress>
			<span class="plyr__tooltip">00:00</span>
		</div>
	</div>
	<div class="plyr__controls__item plyr__time--duration plyr__time" aria-label="Duration">00:00</div>
	<div class="plyr__controls__item plyr__volume c-audio-bar__volume">
		<button type="button" class="plyr__control" data-plyr="mute">
			<svg class="icon--pressed" aria-hidden="true" focusable="false">
				<use xlink:href="#plyr-muted"></use>
			</svg>
			<svg class="icon--not-pressed" aria-hidden="true" focusable="false">
				<use xlink:href="#plyr-volume"></use>
			</svg>
			<span class="label--pressed plyr__sr-only">Unmute</span>
			<span class="label--not-pressed plyr__sr-only">Mute</span>
		</button>
		<div class="plyr__volume-wrapper">
			<input data-plyr="volume" type="range" min="0" max="1" step="0.05" autocomplete="off" role="slider" aria-label="Volume">
		</div>
	</div>
</div>`;
